import { FC, PropsWithChildren, useEffect, useState } from 'react';
import BtModal from '../../../ts-components/bt-modal/bt-modal';
import BtButton from '../../../ts-components/bt-button/bt-button';
import { CrossSvg } from '../../svgs/cross';
import './Modal.css';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string | React.ReactNode,
  show: boolean,
  setShow: (value: boolean) => void,
  buttonInfo?: {label: string, action: () => void} & any,
  hasCloseButton?: boolean,
  isScrollable?: boolean,
  cancelButtonText?: string,
  onCancelButtonClick?: () => void,
  unmountWhenHidden?: boolean,
  transparentBackground?: boolean,
  containerBeforeButtons?: React.ReactNode,
}

const Modal: FC<PropsWithChildren<Props>> = ({title, show, setShow, buttonInfo, hasCloseButton, children, isScrollable, cancelButtonText, unmountWhenHidden, onCancelButtonClick, transparentBackground, containerBeforeButtons}) => {
  const [delayedTransition, setDelayedTransition] = useState(false);
  const [t] = useTranslation('shared', { keyPrefix: 'modal' });

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (show) {
      setDelayedTransition(true);
    } else {
      timeoutId = setTimeout(() => {
        setDelayedTransition(false);
      }, 500);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [show]);

  let buttonProps = {};
  if (buttonInfo) {
    const { label, action, ...props } = buttonInfo;
    buttonProps = props;
  }

  const buttonContainerShouldRender = !hasCloseButton || buttonInfo?.action || containerBeforeButtons;

  if (unmountWhenHidden && !delayedTransition) {
    return null;
  }

  return (
    <BtModal
      center
      show={show}
      isScrollable={isScrollable}
      transparentBackground={transparentBackground}
      onModalHide={() => {
        if (onCancelButtonClick) {
          onCancelButtonClick();
        } else {
          setShow(false);
        }
      }}
    >
      <div className='simpleModalContainer'>
        <div className='simpleModalContent' style={isScrollable ? { overflowY: 'auto', maxHeight: "90vh", overflowX: 'hidden' } : {}}>
          {hasCloseButton && (
            <div className='simpleModalCloseButton' onClick={() => setShow(false)}>
              <CrossSvg size='16px' />
            </div>
          )}

          <p className='simpleModalTitle'>{title}</p>
          {children}

          {buttonContainerShouldRender && (
            <div className='simpleModalButtonContainer'>
              {containerBeforeButtons}

              {(!hasCloseButton || cancelButtonText || onCancelButtonClick) && (
                <BtButton class='white' onClick={() => {
                  if (onCancelButtonClick) {
                    onCancelButtonClick();
                  } else {
                    setShow(false);
                  }
                }}>{cancelButtonText || t('button.cancel', 'Avbryt')}</BtButton>
              )}

              {buttonInfo?.action && (
                <BtButton onClick={buttonInfo.action} {...buttonProps}>
                  {buttonInfo.label}
                </BtButton>
              )}
            </div>
          )}
        </div>
      </div>
    </BtModal>
  );
}

export default Modal;
